/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      fields: {
        model_class: {
          title: 'Модель',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        model_id: {
          title: 'Id модели',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        parent_id: {
          title: 'Id родителя',
          value: null,
          validate: []
        },
        content: {
          title: 'Комментарий',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        like: {
          title: 'Лайк',
          value: '',
          validate: []
        }
      },
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.SEND_FORM):
        return state;
      case createActionName(name, types.SET_FIELD_MODEL_CLASS):
        return storeSetFieldValue(state, 'model_class', action.payload);
      case createActionName(name, types.SET_FIELD_MODEL_ID):
        return storeSetFieldValue(state, 'model_id', action.payload);
      case createActionName(name, types.SET_FIELD_PARENT_ID):
        return storeSetFieldValue(state, 'parent_id', action.payload);
      case createActionName(name, types.SET_FIELD_CONTENT):
        return storeSetFieldValue(state, 'content', action.payload);
      case createActionName(name, types.SET_FIELD_LIKE):
        return storeSetFieldValue(state, 'like', action.payload);
      case createActionName(name, types.SET_RESULT_OBJECT):
        return state.merge({
          resultObject: action.payload
        });
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/form/reducer.js